import {BasicClient} from '@/utils/httpClient';

export default class Employee {
  client: BasicClient;
  constructor(){
    this.client = new BasicClient();
  }
  unsubscribeEmployee(csvFile,description):any{
        return this.client.exec('/scheduler/unsubscribeUsers', 'POST', {csvFile,description},true);
  }
}